module.exports = __webpack_public_path__ + "static/media/bronzeTop1M.3904cbc6.webp";